module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Youtube-f80662815453adbea25d27b8e3235f0ea2581bc8b7482f4f1a66bc9aa0d40366.svg";